/**
 * TDS · Carrusel de reseñas de Trustpilot (bloque `cita` de pz-producto).
 *
 * Pide las reseñas al App Proxy (/apps/personaliza/resenas), las pinta en
 * una pista con scroll-snap y añade flechas, puntos, teclado y paso
 * automático. SOLO LECTURA: aquí no hay ningún formulario ni envío.
 *
 * Decisiones que importan:
 *   - La pista es un scroll nativo con scroll-snap: el gesto táctil, el
 *     rendimiento y la accesibilidad los da el navegador; el JS solo empuja
 *     con scrollTo y sigue la posición para marcar el punto activo.
 *   - Si no llegan reseñas se enseña la cita de respaldo del bloque (si la
 *     hay) o se oculta el bloque entero: nunca un hueco vacío.
 *   - El paso automático se para al tocar, pasar el ratón o enfocar, y no
 *     se activa si el usuario pidió menos movimiento.
 *
 * Sin console.log. Arranque resistente (load + MutationObserver + eventos
 * del editor), igual que el resto de bloques tds.
 *
 * Idiomas: los textos llegan del snippet ya en el idioma de la página
 * (data-txt-*); aquí solo quedan respaldos por TDS_L. En /it el snippet
 * deja además un bloque JSON [data-tds-tp-trad] con las reseñas traducidas
 * por id: esas se pintan en italiano (lang="it") con una nota al pie; las
 * que no están se quedan en su idioma, con su lang.
 */
(function () {
  'use strict';

  var TDS_L = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || "").slice(0, 2);

  var MENOS_MOVIMIENTO =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatearFecha(iso, idioma) {
    if (!iso) return '';
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    try {
      return new Intl.DateTimeFormat(idioma || 'es', { day: 'numeric', month: 'short', year: 'numeric' }).format(d);
    } catch (e) {
      return m[3] + '/' + m[2] + '/' + m[1];
    }
  }

  function formatearNumero(n, idioma) {
    try {
      return new Intl.NumberFormat(idioma || 'es').format(n);
    } catch (e) {
      return String(n);
    }
  }

  // Cuando el cliente no pone título, Trustpilot lo fabrica con el inicio
  // del texto y "…": mostrarlo sería repetir la primera línea en negrita.
  function tituloRedundante(r) {
    var t = String(r.titulo || '').replace(/[…\.]+\s*$/, '').trim().toLowerCase();
    var x = String(r.texto || '').trim().toLowerCase();
    return t.length > 0 && x.indexOf(t) === 0;
  }

  function barajar(lista) {
    for (var i = lista.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = lista[i];
      lista[i] = lista[j];
      lista[j] = t;
    }
    return lista;
  }

  // Bloque JSON que el snippet deja solo en /it y /de ([data-tds-tp-trad]):
  //   { nota, calificacion: { "Excelente": "…" }, resenas: { id: { titulo, texto } } }
  // Si no está o no se puede leer → null y todo sale como siempre.
  function leerTraduccion(raiz) {
    var nodo = raiz.querySelector('[data-tds-tp-trad]');
    if (!nodo) return null;
    try {
      var t = JSON.parse(nodo.textContent || '');
      return t && typeof t === 'object' ? t : null;
    } catch (e) {
      return null;
    }
  }

  function tieneClave(obj, clave) {
    return !!obj && typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, clave);
  }

  function iniciar(raiz) {
    if (!raiz || raiz.__tdsTp) return;
    raiz.__tdsTp = true;

    var carrusel = raiz.querySelector('[data-tds-tp-carrusel]');
    var pista = raiz.querySelector('[data-tds-tp-pista]');
    var plantilla = raiz.querySelector('[data-tds-tp-plantilla]');
    var cargando = raiz.querySelector('[data-tds-tp-cargando]');
    var respaldo = raiz.querySelector('[data-tds-tp-respaldo]');
    var aviso = raiz.querySelector('[data-tds-tp-aviso]');
    var puntos = raiz.querySelector('[data-tds-tp-puntos]');
    var btnAnt = raiz.querySelector('[data-tds-tp-ant]');
    var btnSig = raiz.querySelector('[data-tds-tp-sig]');
    if (!carrusel || !pista || !plantilla) return;

    var endpoint = raiz.getAttribute('data-endpoint') || '/apps/personaliza/resenas';
    var limite = parseInt(raiz.getAttribute('data-limite'), 10) || 10;
    var minimo = parseInt(raiz.getAttribute('data-min'), 10) || 5;
    var orden = raiz.getAttribute('data-orden') || 'recientes';
    var autoplayMs = parseInt(raiz.getAttribute('data-autoplay'), 10) || 0;
    var mostrarTitulo = raiz.getAttribute('data-mostrar-titulo') === '1';
    var txtLeerMas = raiz.getAttribute('data-txt-leer-mas') || (TDS_L === "de" ? "Mehr lesen" : TDS_L === "en" ? "Read more" : TDS_L === "it" ? "Leggi di più" : 'Leer más');
    var txtLeerMenos = raiz.getAttribute('data-txt-leer-menos') || (TDS_L === "de" ? "Weniger lesen" : TDS_L === "en" ? "Read less" : TDS_L === "it" ? "Leggi meno" : 'Leer menos');
    var txtIr = raiz.getAttribute('data-txt-ir') || (TDS_L === "de" ? "Zur Bewertung" : TDS_L === "en" ? "Go to review" : TDS_L === "it" ? "Vai alla recensione" : 'Ir a la reseña');
    var idioma = (document.documentElement.getAttribute('lang') || 'es').slice(0, 5);
    var trad = leerTraduccion(raiz);
    var notaTrad = trad && typeof trad.nota === 'string' ? trad.nota.trim() : '';

    var actual = 0;
    var total = 0;
    var temporizador = null;
    var pausado = false;

    // ---- sin reseñas: respaldo o nada ----
    function sinResenas() {
      if (cargando) cargando.hidden = true;
      carrusel.hidden = true;
      if (respaldo) {
        respaldo.hidden = false;
      } else if (aviso) {
        aviso.hidden = false; // solo existe en el editor
      } else {
        raiz.hidden = true;
      }
    }

    // ---- cabecera (puntuación real) ----
    function pintarNegocio(n) {
      if (!n) return;
      var p = raiz.querySelector('[data-tds-tp-puntuacion]');
      var t = raiz.querySelector('[data-tds-tp-total]');
      var c = raiz.querySelector('[data-tds-tp-calif]');
      if (p && typeof n.puntuacion === 'number') p.textContent = formatearNumero(n.puntuacion, idioma);
      if (t && typeof n.total === 'number') t.textContent = formatearNumero(n.total, idioma);
      if (c && n.calificacion) {
        var cal = trad && tieneClave(trad.calificacion, n.calificacion) ? trad.calificacion[n.calificacion] : '';
        c.textContent = typeof cal === 'string' && cal ? cal : n.calificacion;
      }
      pintarEstrellas(raiz.querySelector('[data-tds-tp-estrellas-cab]'), Math.round(n.puntuacion || 5));
    }

    function pintarEstrellas(nodo, n) {
      if (!nodo) return;
      var es = nodo.querySelectorAll('.tds-tp__e');
      for (var i = 0; i < es.length; i++) es[i].classList.toggle('is-vacia', i >= n);
    }

    // ---- reseñas ----
    // La reseña con título y texto traducidos si el bloque JSON la trae por
    // su id; si no, null y se pinta la original, en su idioma.
    function traducida(r) {
      if (!trad || !r || !tieneClave(trad.resenas, r.id)) return null;
      var t = trad.resenas[r.id];
      if (!t || typeof t.texto !== 'string' || !t.texto.trim()) return null;
      return {
        id: r.id,
        nombre: r.nombre,
        estrellas: r.estrellas,
        fecha: r.fecha,
        titulo: typeof t.titulo === 'string' ? t.titulo : '',
        texto: t.texto,
        idioma: (trad && typeof trad.idioma === 'string' && trad.idioma) || 'it'
      };
    }

    function crearResena(r, i) {
      var tr = traducida(r);
      if (tr) r = tr;
      var frag = plantilla.content.cloneNode(true);
      var art = frag.querySelector('.tds-tp__resena');
      art.setAttribute('aria-label', (i + 1) + ' / ' + total);
      art.setAttribute('data-indice', String(i));
      if (r.idioma) art.setAttribute('lang', r.idioma);
      pintarEstrellas(art.querySelector('[data-estrellas]'), r.estrellas);
      var fecha = art.querySelector('[data-fecha]');
      if (fecha) {
        if (r.fecha) {
          fecha.textContent = formatearFecha(r.fecha, idioma);
          fecha.setAttribute('datetime', r.fecha);
        } else {
          fecha.hidden = true;
        }
      }
      var titulo = art.querySelector('[data-titulo]');
      if (titulo) {
        if (mostrarTitulo && r.titulo && !tituloRedundante(r)) titulo.textContent = r.titulo;
        else titulo.hidden = true;
      }
      var texto = art.querySelector('[data-texto]');
      if (texto) texto.textContent = r.texto;
      var nombre = art.querySelector('[data-nombre]');
      if (nombre) nombre.textContent = r.nombre;
      // Al pie y discreta: que se sepa que la reseña está traducida.
      if (tr && notaTrad) {
        var marca = document.createElement('span');
        marca.className = 'tds-tp__traducida';
        marca.textContent = notaTrad;
        art.appendChild(marca);
      }

      var mas = art.querySelector('[data-mas]');
      if (mas && texto) {
        mas.textContent = txtLeerMas;
        mas.addEventListener('click', function () {
          var abierta = art.classList.toggle('is-abierta');
          mas.textContent = abierta ? txtLeerMenos : txtLeerMas;
          mas.setAttribute('aria-expanded', abierta ? 'true' : 'false');
          ajustarAlto();
          parar(); // quien está leyendo no quiere que se le vaya
        });
      }
      return frag;
    }

    // "Leer más" solo si el texto quedó recortado de verdad.
    function ajustarRecortes() {
      var arts = pista.querySelectorAll('.tds-tp__resena');
      for (var i = 0; i < arts.length; i++) {
        var texto = arts[i].querySelector('[data-texto]');
        var mas = arts[i].querySelector('[data-mas]');
        if (!texto || !mas) continue;
        if (arts[i].classList.contains('is-abierta')) continue;
        mas.hidden = !(texto.scrollHeight > texto.clientHeight + 1);
      }
    }

    function crearPuntos() {
      if (!puntos) return;
      puntos.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tds-tp__punto';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', txtIr + ' ' + (i + 1));
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.setAttribute('data-indice', String(i));
        puntos.appendChild(b);
      }
      puntos.addEventListener('click', function (ev) {
        var p = ev.target.closest ? ev.target.closest('[data-indice]') : null;
        if (!p) return;
        irA(parseInt(p.getAttribute('data-indice'), 10));
        parar();
      });
    }

    function marcar(i) {
      actual = i;
      if (puntos) {
        var ps = puntos.querySelectorAll('.tds-tp__punto');
        for (var k = 0; k < ps.length; k++) ps[k].setAttribute('aria-selected', k === i ? 'true' : 'false');
      }
      // Las flechas no se deshabilitan: el carrusel es circular.
      ajustarAlto();
    }

    // La pista mide lo que mide la reseña visible, no la más larga.
    function ajustarAlto() {
      var art = pista.querySelector('.tds-tp__resena[data-indice="' + actual + '"]');
      if (art) pista.style.height = art.offsetHeight + 'px';
    }

    function irA(i, instantaneo) {
      if (total === 0) return;
      i = ((i % total) + total) % total;
      var ancho = pista.clientWidth;
      try {
        pista.scrollTo({ left: i * ancho, behavior: instantaneo || MENOS_MOVIMIENTO ? 'auto' : 'smooth' });
      } catch (e) {
        pista.scrollLeft = i * ancho;
      }
      marcar(i);
    }

    // Seguir el dedo: el índice se deduce de la posición del scroll.
    var rafScroll = null;
    pista.addEventListener('scroll', function () {
      if (rafScroll) return;
      rafScroll = requestAnimationFrame(function () {
        rafScroll = null;
        var ancho = pista.clientWidth || 1;
        var i = Math.round(pista.scrollLeft / ancho);
        if (i !== actual && i >= 0 && i < total) marcar(i);
      });
    });

    // ---- paso automático ----
    function arrancar() {
      if (!autoplayMs || MENOS_MOVIMIENTO || total < 2 || pausado) return;
      parar();
      temporizador = setInterval(function () {
        if (document.hidden) return;
        // Si la reseña abierta se está leyendo, no se pasa de largo.
        var abierta = pista.querySelector('.tds-tp__resena.is-abierta');
        if (abierta && parseInt(abierta.getAttribute('data-indice'), 10) === actual) return;
        irA(actual + 1);
      }, autoplayMs);
    }
    function parar() {
      if (temporizador) clearInterval(temporizador);
      temporizador = null;
    }
    function pausar() { pausado = true; parar(); }
    function reanudar() { pausado = false; arrancar(); }

    raiz.addEventListener('mouseenter', pausar);
    raiz.addEventListener('mouseleave', reanudar);
    raiz.addEventListener('focusin', pausar);
    raiz.addEventListener('focusout', function (ev) {
      if (!raiz.contains(ev.relatedTarget)) reanudar();
    });
    pista.addEventListener('touchstart', pausar, { passive: true });
    pista.addEventListener('touchend', function () {
      // Tras el gesto, un respiro antes de volver a pasar solas.
      setTimeout(reanudar, 4000);
    }, { passive: true });

    // Solo pasa sola mientras se ve: fuera de pantalla no gasta nada.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        for (var i = 0; i < entradas.length; i++) {
          if (entradas[i].isIntersecting) arrancar();
          else parar();
        }
      }, { threshold: 0.4 }).observe(raiz);
    }

    // ---- controles ----
    if (btnAnt) btnAnt.addEventListener('click', function () { irA(actual - 1); parar(); });
    if (btnSig) btnSig.addEventListener('click', function () { irA(actual + 1); parar(); });
    pista.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowLeft') { ev.preventDefault(); irA(actual - 1); parar(); }
      else if (ev.key === 'ArrowRight') { ev.preventDefault(); irA(actual + 1); parar(); }
      else if (ev.key === 'Home') { ev.preventDefault(); irA(0); parar(); }
      else if (ev.key === 'End') { ev.preventDefault(); irA(total - 1); parar(); }
    });

    // Al cambiar el ancho (giro del móvil, editor), se recoloca la actual.
    var rafResize = null;
    window.addEventListener('resize', function () {
      if (rafResize) cancelAnimationFrame(rafResize);
      rafResize = requestAnimationFrame(function () {
        irA(actual, true);
        ajustarRecortes();
        ajustarAlto();
      });
    });

    // ---- carga ----
    function pintar(datos) {
      pintarNegocio(datos.negocio);
      var lista = Array.isArray(datos.resenas) ? datos.resenas.slice() : [];
      if (orden === 'aleatorio') barajar(lista);
      total = lista.length;
      if (!total) { sinResenas(); return; }

      pista.innerHTML = '';
      for (var i = 0; i < total; i++) pista.appendChild(crearResena(lista[i], i));
      crearPuntos();
      carrusel.classList.toggle('is-unica', total < 2);
      if (cargando) cargando.hidden = true;
      if (respaldo) respaldo.hidden = true;
      carrusel.hidden = false;
      ajustarRecortes();
      marcar(0);
      arrancar();
    }

    var url =
      endpoint +
      '?limite=' + encodeURIComponent(limite) +
      '&min=' + encodeURIComponent(minimo);

    fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || d.success !== true) { sinResenas(); return; }
        pintar(d);
      })
      .catch(sinResenas);
  }

  function arrancarTodos(ambito) {
    var nodos = (ambito || document).querySelectorAll('[data-tds-tp]');
    Array.prototype.forEach.call(nodos, iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arrancarTodos(document); });
  } else {
    arrancarTodos(document);
  }
  window.addEventListener('load', function () { arrancarTodos(document); });

  if ('MutationObserver' in window) {
    var vigilante = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodos = muts[i].addedNodes;
        for (var j = 0; j < nodos.length; j++) {
          var n = nodos[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-tds-tp]')) iniciar(n);
          else if (n.querySelectorAll) arrancarTodos(n);
        }
      }
    });
    var vigilar = function () {
      if (document.body) vigilante.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) vigilar();
    else document.addEventListener('DOMContentLoaded', vigilar);
  }

  document.addEventListener('shopify:section:load', function (ev) { arrancarTodos(ev.target); });
})();
